import React from 'react';

import { Site } from 'src/redux/jira/types';
import jiraUrls from 'src/urls/jira';
import { captureExceptionWithTags } from 'src/utils/sentry';

export const useRovoEnabledSitesForWorkspace = (workspaceUuid: string) => {
  const [rovoEnabledSites, setRovoEnabledSites] = React.useState<Site[]>([]);

  React.useEffect(() => {
    if (!workspaceUuid) {
      return;
    }

    fetch(jiraUrls.api.internal.connectedSites(workspaceUuid))
      .then(res => {
        res.json().then((data: { values: Site[] }) => {
          const sites = data.values.filter(site => site.isRovoEnabled);
          setRovoEnabledSites(sites);
          return data;
        });
      })
      .catch(error => {
        captureExceptionWithTags(error);
      });
  }, [workspaceUuid]);

  return { rovoEnabledSites };
};
